import _ from 'lodash';

function validDateCopy(date) {
    if (!angular.isDate(date))
        return null;
    if (isNaN(date.getTime()))
        return null;
    return new Date(date);
}

ErgoPickerController.$inject = ['$scope', '$attrs'];
function ErgoPickerController($scope, $attrs) {

    this.modelCtrl = null;
    this.date = null;
    this.disabled = void(0);

    this.init = (ngModelCtrl) => {
        this.modelCtrl = ngModelCtrl;

        ngModelCtrl.$render = () => {
            this.date = validDateCopy(ngModelCtrl.$viewValue);
        };

        if (angular.isDefined($attrs.mindate)) {
            let validateMin = null;
            $scope.$parent.$watch($attrs.mindate, function (value) {
                validateMin = validDateCopy(value);
                ngModelCtrl.$validate();
            });
            ngModelCtrl.$validators.mindate = function (modelValue, viewValue) {
                var value = modelValue || viewValue;
                if (value == null)
                    return true;
                if (validateMin == null)
                    return true;
                return validateMin <= value;
            };
        }

        if (angular.isDefined($attrs.maxdate)) {
            let validateMax = null;
            $scope.$parent.$watch($attrs.maxdate, function (value) {
                validateMax = validDateCopy(value);
                ngModelCtrl.$validate();
            });
            ngModelCtrl.$validators.maxdate = function (modelValue, viewValue) {
                var value = modelValue || viewValue;
                if (value == null)
                    return true;
                if (validateMax == null)
                    return true;
                return validateMax >= value;
            };
        }

        $scope.$watch(function () {
            return $attrs.disabled;
        }, (value) => {
            this.disabled = !!value;
        });
    };

    this.dateChanged = (newdate) => {
        this.date = newdate;
        this.modelCtrl?.$setViewValue(newdate);
    };
}

angular.module("tromanWeb").directive("ergoDatepicker", [function () {

    return {
        restrict: "E",
        scope: {},
        controller: ErgoPickerController,
        controllerAs: '$ctrl',
        require: ["ergoDatepicker", "ngModel"],
        template: '<react-date-picker date="$ctrl.date" on-change="$ctrl.dateChanged" disabled="$ctrl.disabled"></react-date-picker>',
        link: function (_scope, element, _attributes, controllers) {
            var ctrl = controllers[0];
            var ngModelCtrl = controllers[1];
            element.addClass('ergo-datepicker');
            ctrl.init(ngModelCtrl);
        }
    };
}]);
